import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import IconCheck from "../../Resources/svg/Icons/IconCheck";

const NavCase = () => {
  const router = useHistory();

  const stepPosition = useSelector(
    (state: any) => state.simulate.policy.stepPosition
  );

  const navCase = [
    {
      id: 1,
      target: "Datos personales",
      active: true,
      url: "/datos-personales",
    },
    { id: 2, target: "Datos laborales", url: "/datos-laborales" },
    {
      id: 3,
      target: "Declaración de salud",
      url: "/declaracion-de-salud",
    },
    {
      id: 4,
      target: "Datos de beneficiarios",
      url: "/beneficiarios",
    },
    {
      id: 5,
      target: "Datos sobre origen de fondos",
      url: "/info-complementaria-1",
    },
    {
      id: 6,
      target: "Debida diligencia",
      url: '/info-complementaria-2'
    },
    {
      id: 7,
      target: "Verificación de datos",
      url: "/verificacion-simulacion",
    },
  ];

  const handleId = (url: any) => {
    router.push(`/cotizaciones${url}`)
  };

  return (
    <div className="nav-case__border">
      <ul>
        {navCase.map(({ id, target, url }) => (
          <li
            className={` ${stepPosition >= id ? "li-active" : "disabledNav"} ${
              stepPosition <= id ? "nav-case__relative" : " nav-case__before"
            }`}
            key={target}
            onClick={() => (stepPosition >= id ? handleId(url) : null)}
          >
            <Link to="#" className="nav-case__link">
              <div
                className={
                  "circle-default" +
                  (stepPosition == id ? " circle-active" : "") +
                  (stepPosition <= id ? " " : " circle-radius")
                }
              >
                {stepPosition <= id ? id : <IconCheck />}
              </div>
              <div
                className={`case-hover ${
                  stepPosition == id ? "case-active" : ""
                }`}
              >
                {stepPosition <= id ? (
                  target
                ) : (
                  <span data-test="test-li" className="case-active">
                    {target}
                  </span>
                )}
              </div>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default NavCase;
